import { render, staticRenderFns } from "./VideoCapture.vue?vue&type=template&id=150d4f48&"
import script from "./VideoCapture.vue?vue&type=script&lang=js&"
export * from "./VideoCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports